import { render, staticRenderFns } from "./uitvoeringsperiode.vue?vue&type=template&id=9b54e72e"
import script from "./uitvoeringsperiode.vue?vue&type=script&lang=js"
export * from "./uitvoeringsperiode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports